<template>
  <div class="index_container">
    <div class="banner_container">
      <el-image :src="bg" />
    </div>
    <div class="content_container">
      <div class="column_container w1200" v-if="isNotEmptyList(middleColumnList)">
        <el-scrollbar>
          <div class="column_item" v-for="(item, index) in middleColumnList"  :key="index"
               :class="{ active: currColumn.sid === item.sid }"
               @click="handleClickItem(item)">
            <el-image :src="item.icon_path" class="column_icon" />
          </div>
        </el-scrollbar>
      </div>
      <div class="doc_container">
        <doc-list @event="handleDocListEvent" />
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { defineAsyncComponent } from 'vue';
import bg from '../../assets/images/bg.png';

export default {
  name: "index",
  components: {
    DocList: defineAsyncComponent(() => import('../components/DocList.vue')),
  },
  data() {
    return {
      bannerList: [],
      searchValue: '',
      searchArea: 'curr',
      bg,
    };
  },
  computed: {
    ...mapState([ 'columnList', 'currColumn' ]),
    middleColumnList() {
      return this.columnList.filter(item => item.location === 'middle');
    },
  },
  watch: {
    currColumn: {
      handler() {
        this.init();
      },
      deep: true,
      immediate: true,
    },
  },
  methods: {
    init() {
      this.pageIndex = 1;
      this.dataList = [];
      this.requestedPageList = [];
      this.disabledScroll = false;
      this.searchValue = '';
      this.searchArea = 'curr';
      this.initBanner();
    },
    initBanner() {
      this.bannerList = [];
      if (this.isNotEmpty(this.currColumn.ad_url_json)) {
        let list = JSON.parse(this.currColumn.ad_url_json);
        if (this.isNotEmptyList(list)) {
          list.forEach(item => {
            if (this.isNotEmpty(item.icon_url)) {
              item.icon_path = this.getFileUrl(item.icon_url);
            }
            if (this.isNotEmpty(item.main_pic_url)) {
              item.main_pic_path = this.getFileUrl(item.main_pic_url);
            }
          });
        }
        this.bannerList = list;
      }
    },
    handleBannerEvent(event) {
      if (event.type === 'detail') {
        this.handleOpenDetail(event.data);
      }
    },
    handleClickItem(item) {
      this.storeCommit('SET_CURR_COLUMN', item);
      this.$nextTick(() => {
        setTimeout(() => {
          $('.content_layout_container').scrollTop(495);
        }, 100);
      });
    },
    handleDocListEvent(event) {
      if (event.type === 'clickItem') {
        this.handleOpenDetail(event.data);
      }
    },
    handleOpenDetail(item) {
      if (item.is_ex === 1) {
        if (this.isNotEmpty(item.ex_url)) {
          window.open(item.ex_url);
        }
        return;
      }
      let route = this.$router.resolve({
        path: `/detail/${ item.static_url }`,
      });
      window.open(route.href);
    },
  },
}
</script>

<style scoped lang="scss">
.index_container {
  width: 100%;
  height: auto;
  min-height: calc(100% - 150px);

  .banner_container {
    width: 100%;
    height: 495px;
    margin-bottom: 40px;

    .el-image {
      width: 100%;
      height: 100%;
    }
  }

  .content_container {
    height: auto;
    margin: 0 auto;

    .column_container {
      margin: 40px auto;
      display: block;
      white-space: nowrap;
      text-align: center;
      height: 114px;
      vertical-align: middle;

      :deep(.el-scrollbar__view) {

        .column_item {
          width: 282px;
          height: 110px;
          display: inline-block;
          vertical-align: top;
          margin-right: 24px;
          border-radius: 8px;
          background-color: #fff;
          cursor: pointer;

          .column_icon {
            width: 100%;
            height: 100%;
          }

          &:last-child {
            margin-right: 0;
          }

          &.active {
            position: relative;

            &:before {
              content: ' ';
              width: calc(100% - 10px);
              height: 2px;
              background-color: #0A7AFF;
              position: absolute;
              top: 0;
              left: 50%;
              transform: translateX(-50%);
            }
          }
        }
      }

      :deep(.is-vertical) {
        display: none;
      }
    }

    .doc_container {
      min-height: 200px;
      margin-bottom: 60px;
    }
  }
}
</style>